import React from 'react'
import Modal from 'components/Luxkit/Modal/Modal'

import HelpPane from 'components/Common/HelpPane'
import BodyText from 'components/Luxkit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

function BedbankSoldOutModal() {
  const { resolve } = useModalElementContext<void>()
  const modalClose = () => resolve()

  return (
    <Modal
      title="This room option is no longer available"
      primaryActionText="Select a different room option"
      onPrimaryActionClick={modalClose}
    >
      <BodyText variant="large" weight="normal">
        Unfortunately your selected room option sold out before we could secure them.{' '}
        Luckily there are alternative options for you to choose from, but make sure to act fast!
      </BodyText>
      <HelpPane />
    </Modal>
  )
}

export default BedbankSoldOutModal
